import React, {useCallback, useEffect, useState} from 'react';
import styled, {css} from 'styled-components';

import {Dropdown} from 'semantic-ui-react';

import './styles.scss';

import {apiGet, apiPost} from "../services/apiClient";
import SelectPointModal from "../pages/parcels/form_v3/selectPointModal.jsx";
import AddressState from "./addressState";
import Info from "./Info";
import {toast} from "react-toastify";
import debounce from "lodash.debounce";
import SvgNew from "./SvgNew";

const StyledDropdown = styled(Dropdown)`
  ${({$fitParentWidth}) => $fitParentWidth && css`
    min-height: 50px !important;
    font-size: 14px;

    &.ui.dropdown {
      position: absolute;
      width: 100%;
    }
  `}
  
  &.search-query {
    z-index: 10 !important;
  }
  
  &.active, &.active .menu {
    border-color: #135CA9 !important;
  }

  &.active.error, &.active.error .menu {
    border-color: #e0b4b4 !important;
  }

  &.ui.dropdown > .search.icon,
  &.ui.dropdown > .delete.icon,
  &.ui.dropdown > .dropdown.icon {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    top: 12px;
    right: 0.5rem;
  }

  &.ui.dropdown > .dropdown.icon:not(.clear) {
    top: 14px !important;
  }

  .icon.clear {
    position: absolute !important;
    opacity: 0.5 !important;
  }

  &:not(.calc) {
    .icon.clear {
      right: 40px !important;
    }

    .icon:not(.clear) {
      display: none;
    }
  }

  &.active, &.search-query {
    .icon.clear {
      right: 17px !important;
    }
  }

  & > input {
    padding-top: 12px !important;
  }

  &.ui.dropdown:not(.active) > .default.text {
    font-weight: 700;
    font-size: 16px !important;
    color: #939697;
  }

  &.ui.dropdown > .clear.dropdown.icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &.ui.dropdown:not(.multiple), &.ui.search.dropdown:not(.multiple), &.ui.search.selection.dropdown:not(.multiple) > input.search, &.ui.selection.dropdown:not(.multiple), &.ui.selection.search.dropdown:not(.multiple) {
    height: 50px !important;
    align-items: center;
    padding: 15px 35px 15px 15px;
  }

  &.ui.dropdown > .clear.icon:before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &.ui.dropdown > .clear.dropdown.icon {
    right: 1.14285714rem;
  }

  &.ui.dropdown .menu .item {
    display: flex;
    flex-direction: row-reverse;
    padding: 0.7142857142857143rem 0.8571428571428571rem !important;
    justify-content: flex-end;
    align-items: center;
  }

  &.ui.dropdown .menu .bold.item {
    font-weight: 900;
  }


  &:not(.description-for-valid) .ui.dropdown .description + .text {
    color: #aaa;
  }

  &.ui.dropdown > .text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: top;
  }

  &.ui.dropdown.invalid > .text {
    color: #b33030;
  }

  &.ui.dropdown:not(.active) > .text {
    padding-left: 53px;
    padding-right: 20px;
  }

  ${({$isCalc}) => $isCalc && css`
    &.ui.dropdown:not(.active) > .text {
      padding-right: 0;
    }
  `}

  &.ui.dropdown > .text > .description,
  &.ui.dropdown .menu > .item > .description {
    margin-left: auto;
    line-height: 0.8571428571428571rem;
    color: #475566;
    white-space: nowrap;
  }

  &.ui.selection.dropdown {
    border: 1px solid #AAAAAA;
  }

  &.error.ui.selection.dropdown {
    border: 1px solid #e0b4b4 !important;
  }

  &.ui.selection.dropdown.address .menu {
    width: 700px !important;
    border-radius: .2857142857142857rem !important;
    border-top-width: 1px !important;
    margin-top: 2px !important;
  }
  
  .address-item {
    width: 100%;
    display: flex !important;
    justify-content: space-between;
    > div:first-child {
      margin-top: auto;
      margin-bottom: auto;
    }
    &__state {
      white-space: nowrap;
      display: flex;
      flex-direction: column;
      justify-content: center;
      max-width: 150px;
    }
    &__bold {
      font-weight: bold;
    }
    &__grey {
      color: grey;
    }
    mark {
      padding: 0 !important;
      background-color: #fff1cc;
    }
  }
`;

const CountryDropdown = styled(StyledDropdown)`
  z-index: 10;
  position: absolute !important;

  .country__dropdown {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    padding: 15px;
  }
  
  .text {
    margin-left: 40px;
  }

  & .country__flag {
    position: absolute;
    margin-top: -2px;
    z-index: 2;

    &_item {
      margin-left: 4px;
    }
  }

  &.dropdown {
    background-color: rgba(102, 51, 153, 0) !important;
    width: 56px !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    &:not(.active) {
      input.search {
        padding: 0 !important;
        width: 0;
      }
    }
    &:hover {
      border-color: #459EFF !important;
    }
  }

  & .country__input-label {
    display: none;
  }

  .search {
    padding-left: 70px !important;
  }

  &.active.dropdown {
    border-color: #135CA9 !important;
    max-width: 100% !important;
    min-width: 220px;
    background-color: rgba(255, 255, 255, 1) !important;

    .search[value=""] + div {
      .country__input-label {
        display: flex;
        padding-left: 55px;
        color: #939697;
      }
    }
  }
`;

const DropdownBlock = styled.div`
  ${({$width}) => $width && css`
    max-width: calc((100% - ${$width+'px'})/2);
  `}
  position: relative;
  width: 100%;
  margin-right: 8px;

  &:last-child {
    margin-right: 0;
  }

  & > .country.ui.dropdown > .dropdown.icon {
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgOCA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNCA2TDAuNTM1ODk4IDAuNzVMNy40NjQxIDAuNzVMNCA2WiIgZmlsbD0iIzk5OTk5OSIvPgo8L3N2Zz4K') !important;
    left: 42px;
    right: auto;
  }


  .point-dropdown__btn {
    position: absolute;
    top: 16px;
    right: 10px;
    left: auto;
    cursor: pointer;
  }

`

const PointDropdown = ({
                           selectOnBlur = false,
                           tableCell = false,
                           options = [],
                           compact = false,
                           className = '',
                           multiple = false,
                           fitParentWidth = false,
                           style = {},
                           form,
                           onChange,
                           name,
                           label,
                           isCalc,
                           error,
                           companyId,
                           width,
                           ...restProps
                       }) => {

    const [isInvalid, setIsInvalid] = useState(false);
    const [countries, setCountries] = useState([]);
    const [addresses, setAddresses] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchCountryQuery, setSearchCountryQuery] = useState('');
    const [closeOnBlur, setCloseOnBlur] = useState(true);
    const [timer, setTimer] = useState();

    useEffect(() => {
        const el = document.getElementById('point-' + name).children[0];
        el.onblur = () => setCloseOnBlur(true);
        el.onfocus = () => setCloseOnBlur(false);
    }, [searchQuery]);

    const onChangeCountry = (e, {value}) => {
        onChange(name, {countryCode: value});
        setAddresses([]);
        setIsInvalid(false);
        setTimeout(() => document.getElementById('country' + name).children[0].blur(), 100);
    };

    const onChangeAddress = (e, {value: stringValue}, doNotChangeField = false, addressToSearch = false) => {
        let value = addresses.filter(a => a.myAddressId).find(a => a.myAddressId === stringValue);
        if (!value) value = addresses.filter(a => !a.myAddressId).find(a => a.fullName === stringValue);
        if (value && value.isIncomplete) {
            cleanAddress(value.fullName, form[`${name}CountryCode`] || 'RU', doNotChangeField, addressToSearch);
        } else {
            selectAddress(value, doNotChangeField, addressToSearch);
        }
    };

    const selectAddress = (value, doNotChangeField, addressToSearch) => {
        if (!value) {
            setSearchQuery('');
            setIsInvalid(false);
            onChange(name, null, doNotChangeField);
            return;
        }
        setIsInvalid(value.isInvalid);
        setSearchQuery(addressToSearch ? value.fullName : '');
        onChange(name, value, doNotChangeField);
        setCloseOnBlur(true);
        !doNotChangeField && setTimeout(() => document.getElementById('point-' + name).children[0].blur(), 100);
    };

    const setMyAddress = (e, {value}) => {
        setSearchQuery('');
        onChange(name, value, true);
    };

    const loadCountrySuggestions = (text, sessionKey, isShipmentAddress) => {
        const source = isCalc ? 1 : 0; // Calculator = 1, Order = 0
        return apiPost('parcels/addresses/countrySuggestions',
            {
                text: text,
                addressSuggestionType: isShipmentAddress ? 0 : 1,
                sessionKey: sessionKey,
                maxCount: 10,
                source: source,
                companyId
            })
            .then(data => data.entries ? data.entries.map(e => ({
                key: e.id,
                text: e.name,
                value: e.code,
                image: "country-icon-" + e.code.toLowerCase()
            })) : []);
    }

    const loadCitySuggestions = (text, sessionKey, countryCode, isShipmentAddress) => {
        const source = isCalc ? 1 : 0; // Calculator = 1, Order = 0
        if (!text) {
            return apiPost('parcels/addresses/citySuggestions',
                {
                    maxCount: 5,
                    countryCode: countryCode,
                    addressSuggestionType: isShipmentAddress ? 0 : 1,
                    source: source,
                    companyId
                })
                .then(data => data.entries.map(e => ({
                    ...e,
                    id: null
                })));
        } else {
            return apiPost('parcels/addresses/suggestions',
                {
                    text: text,
                    countryCode: countryCode,
                    sessionKey: sessionKey,
                    maxCount: 10,
                    source: source,
                    companyId
                })
                .then(data => data.entries);
        }
    }

    const cleanAddress = (text, countryCode, doNotChangeField, addressToSearch) => {
        return apiPost('parcels/addresses/clean',
            {
                text: text,
                countryCode: countryCode,
                companyId
            })
            .then(data => selectAddress(data, doNotChangeField, addressToSearch));
    }

    const counterToastValue = 15;
    const [counter, setCounter] = useState(counterToastValue - 1);

    const addressListCheck = (addresses, setInit) => {
        if (setInit) setCounter(counterToastValue - 1);
        else if (!addresses.length) setCounter(prevState => {
            return prevState + 1
        });
    }

    useEffect(() => {
        if (counter === counterToastValue) {
            toast.error('Введённый адрес не найден, проверьте правильность выбора страны');
            setCounter(0);
        }
    }, [counter]);

    const searchAddresses = (form, query) => {
        loadCitySuggestions(query, form.sessionKey, form[`${name}CountryCode`] || 'RU', name === 'shipment')
            .then(r => {
                setAddresses(r);
                addressListCheck(r, !query);
            });
    }

    const searchCountries = (form, query) => {
        loadCountrySuggestions(query, form.sessionKey, name === 'shipment')
            .then(r => {
                setCountries(r);
            });
    }

    const searchAddressesDebounce = useCallback(debounce(searchAddresses, 600), []);
    const searchCountriesDebounce = useCallback(debounce(searchCountries, 600), []);

    useEffect(() => {
        //автовыбор единственного результата поиска
        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }
        if (searchQuery !== '' && (searchQuery !== (form[`${name}City`] || {}).fullName) && addresses.length === 1 && addresses[0] && !addresses[0].noAutoSelection) {
            const tmr = setTimeout(() => {
                onChangeAddress(null, {value: addresses[0].fullName}, true, true);
            }, 500);
            setTimer(tmr);
        }
    }, [addresses]);

    useEffect(() => {
        form[`${name}CountryCode`] && searchAddressesDebounce(form, (searchQuery === '' && form[`${name}City`] && form[`${name}City`].fullName) ? form[`${name}City`].fullName : searchQuery)
    }, [searchQuery, (form[`${name}City`] || {}).fullName]);

    useEffect(() => {
        searchCountriesDebounce(form, searchCountryQuery);
    }, [searchCountryQuery]);

    const highlightText = (text, searchTerm) => {
        if (!searchTerm) return text;
        const regex = new RegExp(searchTerm, 'gi');
        if(text) {
        return text.replace(regex, `<mark>$&</mark>`);  
        }}

    const addressItem = (item) => {
        const name = (type) => {
            switch (type) {
                case 'New': return 'Новый адрес';
                case 'Dictionary': return 'Мои адреса';
            }
        }
        return <div className='address-item'>
            <div>
                <div
                    className={item.isRecommended ? 'address-item__bold' : ''}
                    dangerouslySetInnerHTML={{__html: highlightText(item.fullName || item.fullCityAddress, searchQuery)}}
                />
                {(item.contactName || item.companyName) && <div
                    className='address-item__grey'
                    dangerouslySetInnerHTML={{__html: highlightText(`${item.contactName || '—'} / ${item.companyName || '—'}`, searchQuery)}}
                />}
            </div>
            {item.type && !isCalc && <div className='address-item__state'>
                <AddressState code={item.type} name={name(item.type)}/>
            </div>}
        </div>
    }

    const addressItems = (addresses) => {
        return addresses.map((address, index) => ({value: address.myAddressId || address.fullName, text: address.fullName, key: address.fullName+index, content: addressItem(address)}))
    }

    const countryItems = (countries) => {
        return countries.map(country => ({
            value: country.value,
            text: country.text,
            key: country.key,
            image: <div className={`${country.image} country__flag country__flag_item`} />
        }));
    }

    const onOpen = () => {
        if (!searchQuery) {
            !(form[`${name}City`] && form[`${name}City`].fullName) ? searchAddressesDebounce(form) : setSearchQuery(form[`${name}City`].fullName);
        }
    }

    const onOpenCountry = () => {
        if (!searchCountryQuery) {
            searchCountriesDebounce(form);
        }
    }

    const onSearchChange = (e, {searchQuery}) => {
        onChange(name, null);
        setSearchQuery(searchQuery)
    }

    const onSearchCountryChange = (e, {searchQuery}) => {
        setSearchCountryQuery(searchQuery)
    }

    const onClose = () => {
        (searchQuery === (form[`${name}City`] || {}).fullName) && setSearchQuery('');
    }

    const value = (form[`${name}City`] && form[`${name}City`].fullName)
        ? (form[`${name}City`].id || form[`${name}City`].fullName)
        : (!!searchQuery || null);

    const text = (form[`${name}City`] && form[`${name}City`].fullName)
        ? form[`${name}City`].fullName
        : null;

    return <DropdownBlock $width={width + 16}>
        <CountryDropdown
            id={'country' + name}
            trigger={
                <Info
                    key={'county'}
                    label={'Выберите страну'}
                    position={'left'}
                    trigger={
                        <div className='country__dropdown'>
                            <div className={`country-icon-${(form[`${name}CountryCode`] || '').toLowerCase()} country__flag`}/>
                            <div className={'country__input-label'}>{name === 'shipment' ? 'Страна отправителя' : 'Страна получателя'}</div>
                        </div>
                    }
                    offset={[10]}
                />

            }
            className={`selection country ${compact ? 'ultra-compact' : ''} ${tableCell ? 'small hidden-border' : ''} ${className || ''}`.trim()}
            $fitParentWidth={fitParentWidth && !multiple}
            fluid
            noResultsMessage={'Не найдено'}
            selectOnBlur={false}
            closeOnBlur={closeOnBlur}
            options={countryItems(countries)}
            style={style}
            onChange={onChangeCountry}
            selectOnNavigation={false}
            onOpen={onOpenCountry}
            searchQuery={searchCountryQuery}
            onSearchChange={onSearchCountryChange}
            search={() => countryItems(countries)}
        />

        <StyledDropdown
            error={error}
            clearable
            closeOnBlur={closeOnBlur}
            id={'point-' + name}
            selectOnBlur={false}
            value={value}
            className={`point-selection selection address ${compact ? 'ultra-compact' : ''} ${tableCell ? 'small hidden-border' : ''} ${className || ''} ${isCalc ? 'calc' : ''} ${searchQuery ? 'search-query' : ''} ${isInvalid ? 'invalid' : ''}`.trim()}
            $fitParentWidth={fitParentWidth && !multiple}
            $isCalc={isCalc}
            searchQuery={searchQuery}
            onSearchChange={onSearchChange}
            search={() => addressItems(addresses)}
            text={text}
            placeholder={label}
            fluid
            multiple={multiple}
            noResultsMessage={'Не найдено'}
            options={addressItems(addresses)}
            style={style}
            onOpen={onOpen}
            onChange={onChangeAddress}
            onClose={onClose}
            selectOnNavigation={false}
            {...restProps}
        />

        {isInvalid && (
            <div className='point-dropdown__alert'>
                <Info
                    name='Адрес не найден в классификаторе'
                    text='Просьба убедится в верности введенного адреса . Вы можете заказать посылку с таким адресом, но количество предложений от транспортных компаний будет меньше т.к. предложения поступят только от тех компаний, которые допускают расхождения с классификатором. При дальнейшем оформлении просьба указать подробные инструкции для курьеров в полях комментариев к адресам.'
                />
                <span><b>адрес не найден</b></span>
            </div>
        )}

        {!isCalc && <div className='point-dropdown__btn' onClick={() => setOpenModal(true)}>
            <Info
                key={'my-addresses'}
                label={'Мои адреса'}
                position={'center'}
                trigger={
                    <SvgNew name='my-addresses-btn'/>
                }
            />

        </div>}
        <SelectPointModal
            label={'Мои адреса'}
            open={openModal}
            setOpen={setOpenModal}
            companyId={companyId}
            setPoint={setMyAddress}
        />
    </DropdownBlock>

};


export default PointDropdown;



// WEBPACK FOOTER //
// ./App/components/PointDropdown.jsx